import { EdgeListChannelsRepository } from '@/modules/connect/infra'
import type { ListChannels } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeListChannels(): ListChannels {
  return new EdgeListChannelsRepository(makeSupabaseEdgeHttpClient()).execute
}
